<div class="fw-bold bg-white p-3 rounded-5 mb-5 shadow">
    <!-- Primera fila -->
    <div class="row mt-3">
        <div class="col">
            <label for="information" class="labelInformation" disabled>
                {{
        information
                }}
            </label>
        </div>
        <div class="col btn-back text-end">
            <button class="btn btn-secondary" (click)="goBack()">Back</button>
        </div>
    </div>

    <!-- Segunda fila -->
    <div class="row mt-3">
        <div class="col">
            <label for="customerName">Partner name<span class="required">*</span></label>
            <input type="text"
                   class="form-control input-label"
                   [(ngModel)]="partnerSummary.partnerName"
                   disabled />
        </div>
        <div class="col">
            <label for="address">Address</label>
            <input type="text" style="display:none" />  <!-- Чтобы не отображался диалог сохранения адреса -->
            <input type="text" class="form-control input-label" [(ngModel)]="partnerSummary.partnerAddress" disabled />
        </div>
        <div class="col">
            <label for="customerCity">City</label>
            <input type="text"
                   class="form-control input-label"
                   [(ngModel)]="partnerSummary.partnerCity"
                   disabled />
        </div>
    </div>

    <!-- Tercera fila -->
    <div class="row mt-3">
        <div class="col">
            <label for="customerState">State</label>
            <input type="text"
                   class="form-control input-label"
                   [(ngModel)]="partnerSummary.partnerState"
                   disabled />
        </div>
        <div class="col">
            <label for="customerPostalCode">ZIP code</label>
            <input type="number"
                   class="form-control input-label"
                   [(ngModel)]="partnerSummary.partnerPostalCode"
                   disabled />
        </div>
        <div class="col">
            <label for="customerPhone">Contact number<span class="required">*</span></label>
            <input type="text"
                   class="form-control input-label"
                   [(ngModel)]="partnerSummary.partnerPhone"
                   disabled />
        </div>
    </div>

    <!-- Cuarta fila -->
    <div class="row mt-3">
        <div class="col-4">
            <label for="customerEmail">Email<span class="required">*</span></label>
            <input type="text"
                   class="form-control input-label"
                   [(ngModel)]="partnerSummary.partnerEmail"
                   disabled />
        </div>
    </div>
</div>


<div class="fw-bold bg-white p-3 rounded-5 mb-5 shadow">
    <app-list-partner-customers [partnerDataInput]="partnerData" [readOnly]="true"></app-list-partner-customers>
</div>

<div class="fw-bold bg-white p-3 rounded-5 mb-5 shadow">
    <app-list-partner-staff [customerDataInput]="currentPartnerId" [readOnly]="true" />
</div>

